export enum AdditionalPeopleRoleType {
    Officer = 1,
    RegularEmployee = 2,
}
